export const maskEmail = (email) => {
    if (!email || typeof email !== "string") return "";

    const [name, domain] = email.split("@");
    if (!name || !domain) return email;

    const visiblePart = name.length > 1 ? name[0] : "*";
    const masked = "*".repeat(Math.max(name.length - 1, 1));

    return `${visiblePart}${masked}@${domain}`;
};
